<template>
  <div class="input-group no-gutters">
    <div class="input-group-prepend">
      <span class="input-group-text custom-group-addon" v-if="iconClass"><i :class="iconClass"></i></span>
    </div>
    <b-form-input :type="getTypeInput"
                v-if="ShowCode == null ? true : ShowCode"
                class=""
                :style="ShowInput == null ? 'text-align: center; max-width: 80px; border-right: 0px;' : 'text-align: center; width: 100%' "
                ref="codeInput"
                :placeholder="codePlaceholder || $lang.Common.PlaceholderCode"
                :autofocus="autofocus || false"
                v-model="formField.code"
                :state="formField.state"
                :disabled="disabled"
                @input="$emit('getInput', query)"
                @change="onChangeCode" />
    <div class="col">
      <autocomplete ref="AutocompleteZComponent"
                    v-if="ShowInput == null ? true : ShowInput"
                    v-model="query"
                    :placeholder="placeholder"
                    :serializer="serializer"
                    :disabled="disabled"
                    @input="$emit('getInput', query)"
                    :data="data"
                    @hit="onHit"
                    :showOnFocus="showOnFocus"
                    :maxMatches="maxMatches || 10"
                    :inputClass="formField.state == null ? 'autocompleteClass' : 'autocompleteClass is-invalid'" />
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'AutocompleteZ',
  props: [
    'name',
    'formField',
    'placeholder',
    'codePlaceholder',
    'serializer',
    'debounceLength',
    'objId',
    'objCode',
    'iconClass',
    'autofocus',
    'ShowCode',
    'ShowInput',
    'type',
    'returnCallback',
    'disabled',
    'showOnFocus',
    'maxMatches'
  ],
  data () {
    return {
      objSelected: {},
      query: '',
      noSearch: false,
      data: []
      // zref: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    }
  },
  computed: {
    getInfo: function () {
      let result = null
      if (this.objSelected) {
        result = this.objSelected
      }
      return result
    },
    getTypeInput: function () {
      let result = 'number'
      if (this.type) {
        result = this.type
      }
      return result
    }
  },
  methods: {
    clear () {
      this.objSelected = {}
      this.query = ''
      this.data = []
      this.$refs.AutocompleteZComponent.$refs.inputValue = ''
      this.formField.code = ''
    },
    handleInput (newValue) {
      this.$refs.AutocompleteZComponent.handleInput(newValue)
    },
    setValue (value, nameCodigo = null) {
      if (!value) {
        toast.error(`${this.$lang.Common.CouldNotLoadRegister}: ${this.formField.code}`)
        this.formField.code = null
        this.$refs.codeInput.$el.focus()
        return
      }
      this.formField.code = nameCodigo === null ? value.codigo : value[nameCodigo]
      let data = this.$refs.AutocompleteZComponent.serializer(value)
      this.$refs.AutocompleteZComponent.inputValue = data
      this.formField.value = value.id
      this.noSearch = true
      this.query = data
      if (this.returnCallback) {
        this.$emit('return', this.objSelected)
      }
    },
    onChangeCode (value) {
      if (!value || value.trim().length === 0) {
        this.formField.value = null
        this.formField.code = null
        this.clear()
      } else {
        this.$emit('changeCode', value)
      }
    },
    onHit (value) {
      this.objSelected = value
      this.$emit('hit', value)
    }
  },
  watch: {
    query: debounce(function (data) {
      if (
        !data ||
        data.trim().length < parseInt(this.debounceLength) ||
        this.noSearch === true
      ) {
        this.data = []
        if (!data) {
          this.formField.value = null
          this.formField.code = null
          this.clear()
          this.$emit('hit', null)
        }
      } else {
        this.$emit('search', data)
      }
      this.noSearch = false
    }, 800),
    objSelected: function (data) {
      this.noSearch = Boolean(this.query)

      let id = 'id'
      if (this.objId) {
        if (!data.hasOwnProperty(this.objId)) {
          throw new EvalError(`Property {this.objId} not found.`)
        }

        id = this.objId
      }

      let code = 'codigo'
      if (this.objCode) {
        if (!data.hasOwnProperty(this.objCode)) {
          throw new EvalError(`Property {this.objCode} not found.`)
        }

        code = this.objCode
      }

      this.formField.value = data[id] || null
      this.formField.code = data[code] || null
    }
  }
}
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/** Firefox */
/* input[type="number"] {
  -moz-appearance: textfield;
} */
</style>



// WEBPACK FOOTER //
// src/components/forms/AutocompleteZ.vue